import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Components
import Navbar from "./components/Navbar";
import MobileNavigation from "./pages/MobileNavigation";
import PrivateRoute from "./components/PrivateRoute";

// Pages
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Scheduler from "./pages/Scheduler";
import MySchedule from "./pages/MySchedule";
import MyHours from "./pages/MyHours";
import Banners from "./banners/Banners";
import PublicBannerRoster from "./banners/PublicBannerRoster";
import ShootSales from "./pages/ShootSales";
import BookAppointment from "./pages/BookAppointment";
import AddClients from "./pages/AddClients";
import AddStaff from "./pages/AddStaff";
import Management from "./pages/Management";
import StaffList from "./pages/StaffList";
import DayOffRequests from "./pages/DayOffRequests";
import ClientList from "./pages/ClientList";
import ActivityLog from "./pages/ActivityLog";
import Privacy from "./pages/Privacy"; // ✅ Import Privacy Page
import AdminDashboard from "./pages/AdminDashboard"; // ✅ Import Privacy Pag
import DebugToken from "./pages/DebugToken"; // Import the debug page

function StaffApp() {
  return (
    <AuthProvider>
        <Navbar />
        <MobileNavigation />
        <Routes>
          {/* Publicly accessible routes */}
          <Route path="/login" element={<Login />} />
          
          

          {/* Any logged-in user can access these links */}
          <Route path="/shoot-sales" element={<PrivateRoute><ShootSales /></PrivateRoute>} />
          <Route path="/banners/*" element={<PrivateRoute><Banners /></PrivateRoute>} />
          <Route path="/my-hours" element={<PrivateRoute><MyHours /></PrivateRoute>} />
          <Route path="/my-schedule" element={<PrivateRoute><MySchedule /></PrivateRoute>} />
          <Route path="/scheduler" element={<PrivateRoute><Scheduler /></PrivateRoute>} />
          <Route path="/stafflist" element={<PrivateRoute><StaffList /></PrivateRoute>} />
          <Route path="/clientlist" element={<PrivateRoute><ClientList /></PrivateRoute>} />
          <Route path="/debug-token" element={<PrivateRoute ><DebugToken /></PrivateRoute>} /> 


          {/* Admin-only routes */}
          <Route path="/addclients" element={<PrivateRoute requiredRole="admin"><AddClients /></PrivateRoute>} />
          <Route path="/bookappointment" element={<PrivateRoute requiredRole="admin"><BookAppointment /></PrivateRoute>} />
          <Route path="/activitylog" element={<PrivateRoute requiredRole="admin"><ActivityLog /></PrivateRoute>} />

          {/* Superadmin-only routes */}
          <Route path="/dayoffrequests" element={<PrivateRoute><DayOffRequests /></PrivateRoute>} />
          <Route path="/management" element={<PrivateRoute requiredRole="superadmin"><Management /></PrivateRoute>} />
          <Route path="/addstaff" element={<PrivateRoute requiredRole="superadmin"><AddStaff /></PrivateRoute>} />
          <Route path="/signup" element={<PrivateRoute requiredRole="superadmin"><Signup /></PrivateRoute>} /> 
          <Route path="/privacy" element={<PrivateRoute requiredRole="superadmin"><Privacy /></PrivateRoute>} /> 
          <Route path="/admin" element={<PrivateRoute requiredRole="superadmin"><AdminDashboard /></PrivateRoute>} /> 
          

          {/* Redirect root to login if not authenticated */}
        <Route path="*" element={<Navigate to="/login" />} />

        </Routes>
    </AuthProvider>
  );
}

function App() {
  return <Router><Routes>
    <Route path="/banner-roster" element={<PublicBannerRoster />} />
    <Route path="*" element={<StaffApp />} />
  </Routes></Router>;
}

export default App;
